import React, { useEffect, useState, createElement, Component } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { UtmCapture } from '../components/UtmCapture';
import { EventsLeadForm } from '../components/EventsLeadForm';
import { getUtmParams } from '../utils/utmTracking';
import { motion } from 'framer-motion';
import { Calendar, Users, Gift, Sparkles, Coffee, Utensils, Waves, Droplets, Heart, Wine, Smile, Send, CheckCircle2 } from 'lucide-react';
const ourEvents = [{
  title: 'ימי גיבוש לחברות',
  description: 'יום מלא של פעילויות ימיות, משחקי קבוצה ובניית צוות. חוויה שתחזק את הקשרים בצוות ותיצור זיכרונות משותפים.',
  image: 'https://cdn.magicpatterns.com/uploads/6eVwxnd5NhVtYfdQz83Mv5/חברות.jpg',
  color: 'from-blue-500 to-cyan-400'
}, {
  title: 'אירועים משפחתיים',
  description: 'ימי הולדת, בר/בת מצווה, מסיבות משפחתיות ואירועים מיוחדים. יום בלתי נשכח לכל המשפחה על חוף הכנרת.',
  image: 'https://cdn.magicpatterns.com/uploads/9X5FNE8zK66yqawi4si15S/GetAttachmentThumbnail_(1).jpg',
  color: 'from-pink-500 to-rose-400'
}, {
  title: 'סדנאות קונספט',
  description: 'בוקר נשי, מסיבת רווקות או סתם מפגש חברים. חוויה מיוחדת שמחברת בין ים, רוגע וחברות טובה.',
  image: 'https://cdn.magicpatterns.com/uploads/2qPvWfrpuA9zC4zk67VF34/cf6f08e4-6b6e-4138-add5-a6c3e0976860_(1).jpg',
  color: 'from-purple-500 to-pink-400'
}];
const eventIncludes = [{
  icon: Utensils,
  title: 'ארוחות לבחירה',
  description: 'ממגוון תפריטים מותאמים אישית',
  image: 'https://cdn.magicpatterns.com/uploads/9K1K7Y8duPn8u1ZWuc6RZi/IMG_7629.jpg'
}, {
  icon: Waves,
  title: 'שימוש חופשי בציוד חתירה',
  description: 'כל ציוד המועדון והדרכה בסיסית',
  image: 'https://cdn.magicpatterns.com/uploads/uL5iLVfpHFdEsjuc5CjUj3/סאפים.jpg'
}, {
  icon: Coffee,
  title: 'מתקני כפר הנופש',
  description: 'בריכת שחייה וחוף מפנק',
  image: 'https://cdn.magicpatterns.com/uploads/hzvVTdRCydoPmYWgD5KmjT/1000327273.jpg'
}, {
  icon: Waves,
  title: 'טיול סאפים מודרך',
  description: 'חוויה מודרכת על מי הכנרת',
  image: 'https://cdn.magicpatterns.com/uploads/rMrufAv5CVsqC9RME1SMeN/image.png'
}, {
  icon: Heart,
  title: 'תרגול יוגה קבוצתי על הסאפ',
  description: 'שילוב מושלם של רוגע ואיזון',
  image: 'https://cdn.magicpatterns.com/uploads/1i37x3Y3o2Enq3mpME5bRw/יוגה.jpg'
}, {
  icon: Droplets,
  title: 'בריכת קרח',
  description: 'חוויה מרעננת ומחזקת',
  image: 'https://cdn.magicpatterns.com/uploads/sBpCmAgnydbLtGTXjGZ9we/thumbnail_IMG_2737.jpg'
}, {
  icon: Heart,
  title: 'מתחם עיסויים',
  description: 'מטפלים מקצועיים לרוגע מושלם',
  image: 'https://cdn.magicpatterns.com/uploads/ku2nCKD6NhCAd3mEmKjL3n/55D1CBB6-56A8-4025-9FEE-23F89E29A899.jpg'
}, {
  icon: Sparkles,
  title: 'כל דבר אחר שתחלמו עליו',
  description: 'אנחנו נבנה את האירוע המושלם עבורכם',
  image: 'https://cdn.magicpatterns.com/uploads/ozTxaeTJ3uPnJdnbNHjUnP/IMG_7518_(2).jpg'
}];
export function EventsPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.fullName.trim() || !formData.phone.trim()) return;
    setIsSubmitting(true);
    // Capture UTM params
    const utmParams = getUtmParams();
    // Track Meta Pixel event for Lead
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead', {
        content_name: 'Events and Workshops',
        currency: 'ILS'
      });
    }
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      // Redirect to WhatsApp after successful submission
      const text = encodeURIComponent(`היי, השארתי פרטים בדף אירועים וסדנאות.\nשם: ${formData.fullName}\nטלפון: ${formData.phone}`);
      window.open(`https://wa.me/972548800260?text=${text}`, '_blank');
    }, 1000);
  };
  useEffect(() => {
    // Set meta tags for Events page
    document.title = "אירועים וסדנאות | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'אירועים וסדנאות בכנרת - ימי גיבוש לחברות, אירועים משפחתיים, סדנאות קונספט. חוויה בלתי נשכחת על חוף הכנרת');
    // Open Graph tags
    const ogTags = [{
      property: 'og:title',
      content: "אירועים וסדנאות | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'אירועים וסדנאות בכנרת - ימי גיבוש, אירועים משפחתיים וסדנאות מיוחדות על חוף הכנרת'
    }, {
      property: 'og:type',
      content: 'website'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-953">
      <UtmCapture data-id="element-954" />
      <Navigation data-id="element-955" />

      {/* Hero Section with Form */}
      <section className="relative min-h-[80vh] flex items-center pt-24 pb-12 overflow-hidden" id="hero-form" data-id="element-956">
        <div className="absolute inset-0 z-0" data-id="element-957">
          <img src="https://cdn.magicpatterns.com/uploads/p194udREcU8JKLbaUPgaLY/GetAttachmentThumbnail_(3).jpg" alt="Events and Workshops" className="w-full h-full object-cover" data-id="element-958" />
          <div className="absolute inset-0 bg-gradient-to-l from-black/90 via-black/60 to-black/20" data-id="element-959"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10" data-id="element-960">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-961">
            {/* Text Content */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8
          }} className="text-white" data-id="element-962">
              <Calendar className="w-12 h-12 mb-6 text-blue-200" data-id="element-963" />
              <h1 className="text-5xl md:text-7xl font-bold mb-4 leading-tight" data-id="element-964">
                אירועים וסדנאות
              </h1>
              <p className="text-xl md:text-2xl max-w-2xl font-light mb-8" data-id="element-965">
                חוויות בלתי נשכחות על מי הכנרת. ימי גיבוש, אירועים משפחתיים
                וסדנאות מיוחדות.
              </p>

              <div className="space-y-4 hidden md:block" data-id="element-966">
                <div className="flex items-center gap-3" data-id="element-967">
                  <CheckCircle2 className="w-6 h-6 text-cyan-400" data-id="element-968" />
                  <span className="text-lg" data-id="element-969">התאמה אישית לכל קבוצה</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-970">
                  <CheckCircle2 className="w-6 h-6 text-cyan-400" data-id="element-971" />
                  <span className="text-lg" data-id="element-972">לוקיישן מושלם על המים</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-973">
                  <CheckCircle2 className="w-6 h-6 text-cyan-400" data-id="element-974" />
                  <span className="text-lg" data-id="element-975">צוות מקצועי ומנוסה</span>
                </div>
              </div>
            </motion.div>

            {/* Lead Form */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white/10 backdrop-blur-md border border-white/20 p-8 rounded-3xl shadow-2xl max-w-md w-full mx-auto md:mx-0" data-id="element-976">
              {isSubmitted ? <div className="text-center py-8" data-id="element-977">
                  <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-978">
                    <CheckCircle2 className="w-8 h-8 text-emerald-400" data-id="element-979" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-980">
                    איזה כיף!
                  </h3>
                  <p className="text-gray-200" data-id="element-981">
                    הפרטים התקבלו בהצלחה. נחזור אלייך בהקדם עם כל המידע.
                  </p>
                </div> : <>
                  <h3 className="text-2xl font-bold text-white mb-2 text-center" data-id="element-982">
                    בואו נתכנן את האירוע שלכם
                  </h3>
                  <p className="text-gray-300 text-center mb-6 text-sm" data-id="element-983">
                    השאירו פרטים ונחזור אליכם לבניית אירוע מותאם אישית
                  </p>

                  <form onSubmit={handleSubmit} className="space-y-4" data-id="element-984">
                    <div data-id="element-985">
                      <input type="text" name="fullName" value={formData.fullName} onChange={handleFormChange} required placeholder="שם מלא" className="w-full bg-white/90 border-0 rounded-xl py-3 px-4 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-cyan-400 transition-all" data-id="element-986" />
                    </div>
                    <div data-id="element-987">
                      <input type="tel" name="phone" value={formData.phone} onChange={handleFormChange} required dir="ltr" placeholder="טלפון" className="w-full bg-white/90 border-0 rounded-xl py-3 px-4 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-cyan-400 transition-all text-right" data-id="element-988" />
                    </div>
                    <div data-id="element-989">
                      <input type="email" name="email" value={formData.email} onChange={handleFormChange} dir="ltr" placeholder="אימייל (אופציונלי)" className="w-full bg-white/90 border-0 rounded-xl py-3 px-4 text-gray-900 placeholder:text-gray-500 focus:ring-2 focus:ring-cyan-400 transition-all text-right" data-id="element-990" />
                    </div>

                    <button type="submit" disabled={isSubmitting} className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 text-white font-bold py-4 rounded-xl transition-all shadow-lg flex items-center justify-center gap-2 mt-2" data-id="element-991">
                      {isSubmitting ? <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" data-id="element-992"></div> : <>
                          <Send className="w-5 h-5" data-id="element-993" />
                          דברו איתי!
                        </>}
                    </button>
                  </form>
                </>}
            </motion.div>
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4 py-20" data-id="element-994">
        {/* Introduction */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-4xl mx-auto" data-id="element-995">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-6" data-id="element-996">
            אירועים לקבוצות וארגונים בכנרת לחוויה אחרת!
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-997">
            מועדון ביץ' קלאב בכנרת מזמין אתכם לחוויה מיוחדת שתעצים, תגבש ותיתן
            לכם את האוויר והמרחב שאתם צריכים ליום מושלם ביחד.
          </p>
        </motion.div>

        {/* Our Events Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-998">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-999">
            האירועים שלנו
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1000">
            אנחנו מתאימים כל אירוע במיוחד עבורכם
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20 max-w-6xl mx-auto" data-id="element-1001">
          {ourEvents.map((event, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group" data-id="element-1002">
              <div className="relative h-64 overflow-hidden" data-id="element-1003">
                <div className={`absolute inset-0 bg-gradient-to-t ${event.color} opacity-20 z-10`} data-id="element-1004" />
                <img src={event.image} alt={event.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-1005" />
              </div>

              <div className="p-8" data-id="element-1006">
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1007">
                  {event.title}
                </h3>

                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-1008">
                  {event.description}
                </p>

                {event.link && <a href={event.link} className="inline-block text-[#0A5F8F] font-bold hover:text-cyan-600 transition-colors" data-id="element-1009">
                    לפרטים נוספים ←
                  </a>}
              </div>
            </motion.div>)}
        </div>

        {/* What's Included Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20" data-id="element-1010">
          <div className="text-center mb-12" data-id="element-1011">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A5F8F] mb-4" data-id="element-1012">
              מה כלול באירוע?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-1013">
              <span className="font-bold text-[#0A5F8F]" data-id="element-1014">
                אנחנו בונים את האירוע במיוחד עבורכם!
              </span>
              <br data-id="element-1015" />
              כל אירוע מותאם אישית לצרכי הלקוח והקבוצה
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1016">
            {eventIncludes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl border border-blue-100 overflow-hidden" data-id="element-1017">
                {item.image ? <div className="relative h-48 overflow-hidden" data-id="element-1018">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-1019" />
                  </div> : <div className="p-6 pb-0" data-id="element-1020">
                    <div className="bg-white w-12 h-12 rounded-xl flex items-center justify-center shadow-sm" data-id="element-1021">
                      <item.icon className="w-6 h-6 text-[#0A5F8F]" data-id="element-1022" />
                    </div>
                  </div>}
                <div className="p-6" data-id="element-1023">
                  <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-1024">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-1025">{item.description}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Mid-page Lead Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20 bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto" data-id="element-1026">
          <EventsLeadForm variant="light" title="מעוניינים בפרטים נוספים?" subtitle="השאירו פרטים ונחזור אליכם עם הצעה מותאמת אישית" data-id="element-1027" />
        </motion.div>

        {/* Custom Events CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#0A5F8F] to-[#0D7AB8] rounded-3xl p-12 text-center text-white relative overflow-hidden" data-id="element-1028">
          <div className="absolute inset-0 opacity-10" data-id="element-1029">
            <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} data-id="element-1030" />
          </div>

          <div className="relative z-10" data-id="element-1031">
            <Sparkles className="w-16 h-16 mx-auto mb-6 text-blue-200" data-id="element-1032" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1033">
              רוצים לארגן אירוע מיוחד?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-1034">
              נשמח לעזור לכם לתכנן את האירוע המושלם - ימי גיבוש, חגיגות
              משפחתיות, סדנאות ועוד
            </p>
            <div className="max-w-md mx-auto bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8" data-id="element-1035">
              <EventsLeadForm variant="dark" title="השאירו פרטים ונחזור אליכם" subtitle="נבנה יחד את האירוע המושלם עבורכם" data-id="element-1036" />
            </div>
          </div>
        </motion.div>
      </div>

      <ContactSection showTeam={false} data-id="element-1037" />
      <Footer data-id="element-1038" />
    </div>;
}